import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Space, Button, message } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import {
	getDowntimeSubscribers,
	notifyAllSubscribers,
	selectDowntimeSubscribers,
} from '../redux/downtime';
import ConfirmationModal from '../components/ConfirmationModal';
import moment from 'moment';

const DowntimeSystem = () => {
	const dispatch = useDispatch();
	const subscribers = useSelector(selectDowntimeSubscribers);
	const { loading, notifyLoading } = useSelector((state) => state.downtime);
	const [isModalOpen, setIsModalOpen] = useState(false);

	const fetchSubscribers = useCallback(async () => {
		try {
			await dispatch(getDowntimeSubscribers());
		} catch (error) {
			console.error('Error fetching downtime subscribers:', error);
		}
	}, [dispatch]);

	useEffect(() => {
		fetchSubscribers();
	}, [fetchSubscribers]);

	const handleNotifyAll = async (optionalMessage) => {
		try {
			const result = await dispatch(notifyAllSubscribers(optionalMessage)).unwrap();
			message.success(
				`Notified ${result.data.users_notified} subscribers successfully`,
			);
			setIsModalOpen(false);
		} catch (error) {
			message.error(
				error?.message || 'Failed to notify subscribers. Please try again.',
			);
		}
	};

	const columns = [
		{
			title: 'User ID',
			dataIndex: 'user_id',
		},
		{
			title: 'Email',
			dataIndex: 'email',
		},
		{
			title: 'Subscribed At',
			dataIndex: 'timestamp',
			render: (timestamp) => {
				return moment(timestamp).format('MMM DD, YYYY h:mm A');
			},
		},
	];

	return (
		<div>
			<Space style={{ float: 'right', marginBottom: 16 }}>
				<Button
					type="primary"
					loading={notifyLoading}
					disabled={loading || subscribers.length === 0}
					onClick={() => setIsModalOpen(true)}
					style={{ background: '#008E87' }}>
					<BellOutlined /> Notify All
				</Button>
			</Space>

			<ConfirmationModal
				open={isModalOpen}
				onCancel={() => setIsModalOpen(false)}
				onConfirm={handleNotifyAll}
				title="Send Notification"
				message={`Notify all ${subscribers.length} subscriber${subscribers.length !== 1 ? 's' : ''}?`}
				confirmText="Yes"
				cancelText="No"
				loading={notifyLoading}
				showMessageInput={true}
				messagePlaceholder="System maintenance completed. All services are now available."
			/>

			<Table
				dataSource={subscribers}
				columns={columns}
				loading={loading}
				pagination={false}
				size="middle"
			/>
		</div>
	);
};

export default DowntimeSystem;
